// extracted by extract-css-chunks-webpack-plugin
module.exports = {"_sharedGrid":"otpInput___sharedGrid--1hVeW","otpInput":"otpInput__otpInput--15ozz","box":"otpInput__box--3pPuE","boxError":"otpInput__boxError--2nUUF"};